export { useTrackEventInteraction } from './useTrackEventInteraction';
